import React from "react";
import { CreateOrEditGitTrigger } from "./CreateOrEditGitTrigger";
interface EditReleaseCreationGitTriggersPageProps {
    triggerId: string;
}
export function EditReleaseCreationGitTriggersPage({ triggerId }: EditReleaseCreationGitTriggersPageProps) {
    return <CreateOrEditGitTrigger triggerId={triggerId}/>;
}
